import React from 'react';
import { LoginRedirect } from 'components/login-redirect/LoginRedirect';

export const LoginRedirectPage = () => <LoginRedirect />;
